import Vue from 'vue'

export default {

  all () {
    return Vue.http.get(
      `${process.vars.BACKEND_HOST}/api/ui/pricing_settings/`
    )
  }
}
